<cac-dialog-layout title="جزئیات برنامه" (onSubmit)="onSubmit()" [permission]="!!data ? 'EditPlan' : undefined">
  <cac-form-builder [options]="formBuilder"></cac-form-builder>
  <br class="my-4" />
  <app-tree-view [control]="locationControl" [fieldMode]="true" [multiple]="true" [searchable]="true" [disableUnavailableLocations]="true" label="مکان"></app-tree-view>
</cac-dialog-layout>
